import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'iovisit-theme/components';

/**
 * Component that displays title/description and period of artwork
 * Use this in <Modal.Content>
 */

const ArtworkDetailsModal = ({ artwork }) => {
  const description = artwork.main_image_caption ?? artwork.description;
  const title = artwork.title;
  const period = artwork.period;

  return description || title || period ? (
    <div className="modal-artwork-details-image">
      {(description || title) && (
        <div className="text">
          <Icon prefix="fas" icon="landmark" className="icon" />
          {description ? <p>{description}</p> : <p>{title}</p>}
        </div>
      )}
      {period && (
        <div className="text">
          <Icon prefix="fas" icon="book" className="icon" />
          <p>{period}</p>
        </div>
      )}
    </div>
  ) : (
    <></>
  );
};

ArtworkDetailsModal.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  period: PropTypes.string,
};

export default ArtworkDetailsModal;
